import React from 'react';
import Highcharts from 'highcharts';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HighchartsReact from 'highcharts-react-official';
import { Box, CircularProgress, Paper } from '@material-ui/core';
import PeriodicityButton from './utils/PeriodicityButton';
import ExportCsvButton from './utils/ExportCsvButton';
import { exportToCsv, exportToExcel } from './utils/csvExport';
import {
  getActualProductsQuantities,
  getExpectedProductsQuantities
} from '../dashboardActions';

const ItemsChart = ({
  expectedProductsQuantities,
  actualProductsQuantities,
  dispatchGetActualProductsQuantities,
  dispatchGetExpectedProductsQuantities,
  loadingActualProductsQuantities,
  loadingExpectedProductsQuantities
}) => {
  const options = {
    chart: {
      type: 'column'
    },
    title: {
      text: ''
    },
    yAxis: {
      title: {
        text: ''
      }
    },
    credits: {
      enabled: false
    },
    xAxis: {
      type: 'category'
    },
    plotOptions: {
      column: {
        borderRadius: 8
      },
      series: {
        pointWidth: 12
      }
    },
    series: [
      {
        name: 'Pièces prévues',
        color: '#4C76BB',
        data: expectedProductsQuantities.map(expected => ({
          name: expected.period,
          y: expected.quantity
        }))
      },
      {
        name: 'Pièces réceptionnées',
        color: '#72A517',
        data: actualProductsQuantities.map(actual => ({
          name: actual.period,
          y: actual.quantity
        }))
      }
    ]
  };

  return (
    <Paper
      style={{
        paddingTop: 48,
        paddingLeft: 80,
        paddingRight: 80,
        borderRadius: 20
      }}
    >
      <Box display="flex" justifyContent="space-between" mb={4}>
        <Box display="flex" alignItems="center">
          <Box fontSize={21} color="#001C56">
            Pièces
          </Box>
          <ExportCsvButton
            onClick={() => {
              const allPeriods = [
                ...new Set([
                  ...expectedProductsQuantities.map(e => e.period),
                  ...actualProductsQuantities.map(a => a.period)
                ])
              ];
              const columns = [
                'Période',
                'Pièces prévues',
                'Pièces réceptionnées'
              ];
              const rows = allPeriods.map(period => {
                const expected = expectedProductsQuantities.find(
                  e => e.period === period
                );
                const actual = actualProductsQuantities.find(
                  a => a.period === period
                );
                return [
                  period,
                  expected ? expected.quantity : 0,
                  actual ? actual.quantity : 0
                ];
              });
              exportToCsv('pieces', columns, rows);
            }}
            onExcelClick={() => {
              const allPeriods = [
                ...new Set([
                  ...expectedProductsQuantities.map(e => e.period),
                  ...actualProductsQuantities.map(a => a.period)
                ])
              ];
              const columns = [
                'Période',
                'Pièces prévues',
                'Pièces réceptionnées'
              ];
              const rows = allPeriods.map(period => {
                const expected = expectedProductsQuantities.find(
                  e => e.period === period
                );
                const actual = actualProductsQuantities.find(
                  a => a.period === period
                );
                return [
                  period,
                  expected ? expected.quantity : 0,
                  actual ? actual.quantity : 0
                ];
              });
              exportToExcel('pieces', columns, rows);
            }}
          />
        </Box>
        <PeriodicityButton
          defaultPeriodicity="LAST_THREE_MONTH"
          onChange={({ dateFrom, dateTo }) => {
            dispatchGetExpectedProductsQuantities({
              dateFrom,
              dateTo,
              period: 'month'
            });
            dispatchGetActualProductsQuantities({
              dateFrom,
              dateTo,
              period: 'month'
            });
          }}
        />
      </Box>

      {loadingActualProductsQuantities && loadingExpectedProductsQuantities ? (
        <Box display="flex" justifyContent="center" p={20}>
          <CircularProgress size={60} />
        </Box>
      ) : (
        <HighchartsReact highcharts={Highcharts} options={options} />
      )}
    </Paper>
  );
};

const mapStateToProps = state => ({
  expectedProductsQuantities: state.dashboard.expectedProductsQuantities,
  loadingExpectedProductsQuantities:
    state.dashboard.loadingExpectedProductsQuantities,
  actualProductsQuantities: state.dashboard.actualProductsQuantities,
  loadingActualProductsQuantities:
    state.dashboard.loadingActualProductsQuantities
});

const mapDispatchToProps = dispatch => ({
  dispatchGetExpectedProductsQuantities: params =>
    dispatch(getExpectedProductsQuantities(params)),
  dispatchGetActualProductsQuantities: params =>
    dispatch(getActualProductsQuantities(params))
});

ItemsChart.propTypes = {
  expectedProductsQuantities: PropTypes.array,
  actualProductsQuantities: PropTypes.array,
  dispatchGetExpectedProductsQuantities: PropTypes.func,
  dispatchGetActualProductsQuantities: PropTypes.func,
  loadingActualProductsQuantities: PropTypes.bool,
  loadingExpectedProductsQuantities: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(ItemsChart);
